<ng-container *ngIf="slots.controls.length && (maxAndMasterSlots$)?.max?.length" [formGroup]="shopMaxSlots">
    <table class="alternateColor" aria-describedby="" [ngClass]="switchInput?'':'disabledColor'" formArrayName="slotsPerDay">
        <th id="header">
            <tr [ngClass]="[ viewMode == 'TXM' ? 'sticky-row1' : 'fixed-row1']">
                <div class=" form-control m-2 border-0">{{'departmentCapacity.timePeriod'| translate}}</div>
            </tr>
            <tr [ngClass]="[ viewMode == 'TXM' ? 'sticky-row2' : 'fixed-row2']">
                <div class=" form-control m-2 border-0"></div>
            </tr>
            <tr *ngFor="let element of (maxAndMasterSlots$)?.masterSlot">
                <td>
                    <div class=" form-control m-2 border-0">{{element.slotId}}</div>
                </td>
            </tr>
        </th>
        <td *ngFor="let day of daysOfWeek; let j = index" [formGroupName]="dayIndex(day)">
            <tr [ngClass]="[ viewMode == 'TXM' ? 'sticky-row1' : 'fixed-row1']">
                <td>
                    <div class=" form-control m-2 border-0" style="margin-left: -0.5rem !important;">{{getWeekDays(day)}}</div>
                </td>
            </tr>
            <tr [ngClass]="[ viewMode == 'TXM' ? 'sticky-row2' : 'fixed-row2']">    
                <td>
                    <div class=" form-control m-2 border-0" style="margin-left: -0.5px !important;">
                        {{slotTotals[day]}}
                        <span
                            *ngIf="slotTotals[day] && slotTotals[day] != 0"
                            class="cap-indicator"
                            [ngStyle]="{ 'background-image':!switchInput?'url('+ slotTotalStatus[day].split('.svg')[0]+'-disable'+'.svg' +')':'url('+ slotTotalStatus[day] +')' }">
                        </span>
                    </div>
                </td>
            </tr>
            <tr *ngFor="let slot of (maxAndMasterSlots$)?.masterSlot; let i = index" formArrayName="slots" >
                <td [formGroupName]="timeIndex(day, slot)">
                    <input [readonly]="checkIfValidSlot(day, slot)||!switchInput" [ngClass]="checkIfValidSlot(day, slot) ? 'disabled-field' : ''" type="number" min="0" class=" form-control m-2" formControlName="slotValue" />
                </td>
            </tr>
        </td>
    </table>

    <div class="controls" *ngIf="viewMode == 'Team'">
        <div class="cancel" [ngClass] = "isSaveClicked  ? 'enabled' : ''" (click)="onCancel()">{{ 'overrideCapacity.cancel' | translate }}</div>
        <div class="save" [ngClass] = "isSaveClicked ? 'enabled' : ''" (click)="onSave()">{{ 'overrideCapacity.save' | translate }}</div>
    </div>
</ng-container>

